import { Buyer } from "./Buyer";
import { Gig } from "./Gig";
import { Review, ReviewInterface } from "./Review";
import { OrderSummary } from "./OrderSummary";
import { Seller } from "./Seller";

export interface RevisionInterface {
  revisionId: string;
  revisionState: "seen" | "notSeen";
}

export interface RevisionDetailsInterface {
  revisionUnderProcess?: string;
  activeRevision?: string;
  validRevisions: RevisionInterface[];
  inValidRevisions: RevisionInterface[];
}


export interface PaymentMeta {
  recievedPaymentId?: string | null;
  releasedPaymentId?: string | null;
  refundPaymentId?: string | null;
}

// Deprecated: old summary row representation removed. New consolidated summary lives in src/Models/OrderSummary.ts

export interface OrderMetaInterface {
  buyer: Buyer;
  seller: Seller;
  gig: Gig;
  channelId: string;
}

export enum PaymentStatus {
  PAYMENT_TO_GG_PENDING = "PAYMENT_TO_GG_PENDING",
  PAYMENT_TO_GG_SUCCESS = "PAYMENT_TO_GG_SUCCESS",
  PAYMENT_TO_GG_FAILED = "PAYMENT_TO_GG_FAILED",
  PAYMENT_TO_SELLER_PENDING = "PAYMENT_TO_SELLER_PENDING",
  PAYMENT_TO_SELLER_SUCCESS = "PAYMENT_TO_SELLER_SUCCESS",
  PAYMENT_TO_SELLER_FAILED = "PAYMENT_TO_SELLER_FAILED",
  REFUND_TO_BUYER_PENDING = "REFUND_TO_BUYER_PENDING",
  REFUND_TO_BUYER_SUCCESS = "REFUND_TO_BUYER_SUCCESS",
  REFUND_TO_BUYER_FAILURE = "REFUND_TO_BUYER_FAILURE"
}

export enum OrderStatus {
  init = "init",
  pending = "pending",
  readyForDelivery = "readyForDelivery", // When seller submitted the final work and the order is pending approval from buyer
  approvedByBuyer = "approvedByBuyer",
  completed = "completed",
  overdue = "overdue",
  cancelled = "cancelled",
}

export interface OrderInterface {
  id: string;
  status: OrderStatus;
  actionCard: string;
  metaData: OrderMetaInterface;
  deliveryTimeStamp?: Date;
  noOfRevisionsIncluded: number;
  deliverableTypes: string[];
  lastReviewRequestTimeStamp?: Date;
  revisionCharge?: number;
  revisionDetails?: RevisionDetailsInterface;
  attachments: string[];
  deliveryId?: string;
  paymentId?: string;
  paymentMeta?: PaymentMeta;
  paymentStatus: PaymentStatus;
  orderSummary?: OrderSummary;
  createdAt?: Date;
  updatedAt?: Date;
  review?: ReviewInterface;
}

export class Revision implements RevisionInterface {
  revisionId: string;
  revisionState: "seen" | "notSeen";

  constructor(jsonData: any) {
    this.revisionId = jsonData.revisionId;
    this.revisionState = jsonData.revisionState;
  }
}

export class OrderMeta implements OrderMetaInterface {
  buyer: Buyer;
  seller: Seller;
  gig: Gig;
  channelId: string;

  constructor(jsonData: any) {
    this.buyer = new Buyer(jsonData.buyer);
    this.seller = new Seller(jsonData.seller);
    this.gig = new Gig(jsonData.gig);
    this.channelId = jsonData.channelId;
  }
}

export class Order implements OrderInterface {
  id: string;
  status: OrderInterface["status"];
  actionCard: string;
  metaData: OrderMetaInterface;
  deliveryTimeStamp?: Date;
  orderCompletionTimeStamp?: Date;
  noOfRevisionsIncluded: number;
  deliverableTypes: string[];
  lastReviewRequestTimeStamp?: Date;
  revisionCharge?: number;
  revisionDetails?: RevisionDetailsInterface;
  attachments: string[];
  deliveryId?: string;
  paymentId?: string;
  paymentMeta?: PaymentMeta;
  paymentStatus: OrderInterface["paymentStatus"];
  orderSummary?: OrderSummary;
  createdAt?: Date;
  updatedAt?: Date;
  review?: Review;

  constructor(jsonData: any) {
    this.id = jsonData._id;
    this.status = jsonData.status;
    this.actionCard = jsonData.actionCard;
    this.metaData = new OrderMeta(jsonData.metaData);
    this.deliveryTimeStamp = jsonData.deliveryTimeStamp ? new Date(jsonData.deliveryTimeStamp) : undefined;
    this.orderCompletionTimeStamp = jsonData.orderCompletionTimeStamp ? new Date(jsonData.orderCompletionTimeStamp) : undefined;
    this.noOfRevisionsIncluded = jsonData.noOfRevisionsIncluded;
    this.paymentMeta = jsonData.paymentMeta
    this.deliverableTypes = jsonData.deliverableTypes || [];
    this.lastReviewRequestTimeStamp = jsonData.lastReviewRequestTimeStamp ? new Date(jsonData.lastReviewRequestTimeStamp) : undefined;
    this.revisionCharge = jsonData.revisionCharge;
    this.revisionDetails = jsonData.revisionDetails;
    this.attachments = jsonData.attachments || [];
    this.deliveryId = jsonData.deliveryId;
    this.paymentId = jsonData.paymentId;
    this.paymentStatus = jsonData.paymentStatus;
    this.orderSummary = jsonData.orderSummary ? new OrderSummary(jsonData.orderSummary) : undefined;
    this.createdAt = jsonData.createdAt ? new Date(jsonData.createdAt) : undefined;
    this.updatedAt = jsonData.updatedAt ? new Date(jsonData.updatedAt) : undefined;
    if (jsonData.review) {
      this.review = new Review(jsonData.review);
    }
  }
}
